<template>
	<el-drawer v-model="drawerVisible" append-to-body :destroy-on-close="true" size="600px" :title="title">
		<div class="user-center">
			<UploadImg class="user-center-main" v-model:fileList="userHeadFile" :upload-style="{ width: '180px', height: '180px' }">
				<template #tip>头像大小不能超过 5M</template>
			</UploadImg>
		</div>
		<template #footer>
			<el-button @click="drawerVisible = false">取消</el-button>
			<el-button type="primary" @click="handleSubmit">确定</el-button>
		</template>
	</el-drawer>
</template>
<script lang="ts" setup>
import { useAppStore } from '@/store/app'
import { updateUserHeadFile } from '@/api/modules/systemManage/user'
const props = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', modelValue: boolean): void }>()
const drawerVisible = useVModel(props, 'modelValue', emit)
const title = ref('个人中心')
const appStore = useAppStore()
const userHeadFile = ref<string[]>([])
watch(
	() => appStore.userInfo.userHeadFile,
	newVal => {
		userHeadFile.value = newVal
	},
	{ immediate: true },
)
//提交
const handleSubmit = async () => {
	await updateUserHeadFile({ userHeadFile: userHeadFile.value as [string] })
	appStore.userInfo.userHeadFile = userHeadFile.value
	drawerVisible.value = false
}
</script>
<script lang="ts">
export default {
	name: 'UserCenter',
}
</script>
<style lang="scss" scoped>
.user-center {
	@include h-v-c;
	flex-direction: column;
}
</style>
